module.exports = __webpack_public_path__ + "img/6-black.66a42bd9.png";